import { Typography } from '@mui/material';
import { memo, useMemo } from 'react';
import { useListContext } from 'react-admin';
import { useTranslation } from 'react-i18next';
import { getTopbarResultsTextSx } from './SearchModalLayout';
import { GenericSearchItem } from 'components/Search/components/SearchItemsProvider';

/**
 * --------------------------------------------------------
 * Generic - Results Count Component
 * - Text showing of number of list results
 * --------------------------------------------------------
 */

export const SearchModalResultsCountGeneric = memo(() => {
  const { t } = useTranslation();
  const { total } = useListContext<GenericSearchItem>();

  // Translation strings
  const strResultsCount = useMemo(() => {
    if (!total || Number(total) <= 0) {
      return t('blox.general.no_results');
    }
    if (Number(total) === 1) {
      return t('blox.general.count_results_one', { count: Number(total) });
    }
    return t('blox.general.count_results', { count: Number(total) });
  }, [total, t]);

  return (
    <Typography
      data-testid="search-modal-results-count"
      sx={getTopbarResultsTextSx}
    >
      {strResultsCount}
    </Typography>
  );
});
SearchModalResultsCountGeneric.displayName = 'SearchModalResultsCountGeneric';
